var React = require('react');

function IcShareEmail40 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.333 10c-.92 0-1.667.746-1.667 1.667v16.666c0 .92.747 1.667 1.667 1.667h23.333c.921 0 1.667-.746 1.667-1.667V11.667c0-.92-.746-1.667-1.666-1.667H8.332zM10 15.29v11.377h20V15.29l-8.916 7.642a1.667 1.667 0 01-2.169 0L10 15.291zm17.16-1.957H12.839L20 19.472l7.16-6.139z","fill":"currentColor"}));
}

IcShareEmail40.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = IcShareEmail40;

IcShareEmail40.default = IcShareEmail40;
